export function resolveSkedApiBase({
  browserBase = process.env.SKED_API_BROWSER_BASE,
  apiEnvironment = process.env.SKED_API_ENV || process.env.NODE_ENV,
  useLocal = false,
} = {}) {
  if (browserBase) return browserBase;
  if (apiEnvironment === "staging" || apiEnvironment === "dev") {
    return useLocal
      ? "http://localhost:5001"
      : "https://api-staging.skedsocial.com";
  }
  return "https://api.skedsocial.com";
}
